import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { IconButton } from 'src/components/design-system';
import styles from './section-heading.module.scss';

export const SectionHeading = ({ title, onEdit, editLabel, showEdit }) => (
  <div className={styles.heading}>
    <h2 className={styles.title}>{title}</h2>
    {showEdit && (
      <IconButton label={editLabel} onClick={onEdit} className={styles.iconButton}>
        <FontAwesomeIcon icon={faPencil} className={styles.icon} />
      </IconButton>
    )}
  </div>
);
